var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 56,
    viewBox: "0 0 142 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.0947,
    cy: 28,
    rx: 26.0947,
    ry: 26,
    stroke: "white",
    strokeWidth: 3.18935
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5387 30.2182L22.1619 38.3175V38.3121H25.1954L20.322 30.0161C21.8596 29.6757 23.0167 28.9844 23.7881 27.9421C24.5595 26.8997 24.9452 25.6979 24.9452 24.3311C24.9452 23.2144 24.695 22.2199 24.1946 21.3477C23.6891 20.4756 22.9333 19.7843 21.9221 19.2737C20.911 18.7632 19.6705 18.5079 18.2059 18.5079H11.9409V38.3175H14.474V30.2182H17.5387ZM18.2059 28.1441H14.474V20.6404H18.2059C19.5975 20.6404 20.6347 20.9648 21.3123 21.6083C21.9899 22.2518 22.3287 23.1825 22.3287 24.3365C22.3287 25.4905 21.9847 26.4158 21.2967 27.1071C20.6087 27.7985 19.5819 28.1441 18.2059 28.1441Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3052 23.1718C45.4654 21.6775 44.2613 20.5235 42.6926 19.7204V19.7151C41.124 18.9121 39.265 18.5079 37.1207 18.5079H30.9941V38.3175H37.1207C39.265 38.3175 41.124 37.9239 42.6926 37.1369C44.2613 36.3498 45.4654 35.2171 46.3052 33.728C47.1449 32.2443 47.5622 30.4841 47.5622 28.4579C47.5622 26.4317 47.1397 24.6662 46.3052 23.1718ZM44.932 28.4632C44.932 30.9042 44.2665 32.8027 42.9303 34.1588C41.5941 35.5149 39.6558 36.1903 37.1154 36.1903H33.5609V20.6192H37.1154C39.6347 20.6192 41.5677 21.3105 42.9145 22.6932C44.2613 24.0759 44.932 26.0223 44.932 28.4632Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.636 18.8853L72.8152 24.2857H74.8993L71.5499 18.7537C72.6079 18.5274 73.4 18.0642 73.9317 17.3694C74.458 16.6746 74.7238 15.8745 74.7238 14.9639C74.7238 14.2165 74.5537 13.5533 74.2082 12.9743C73.8679 12.39 73.3469 11.9321 72.6504 11.5899C71.954 11.2478 71.1033 11.0794 70.0932 11.0794H65.7869V24.2857H67.5307V18.8853H69.636ZM70.0932 17.501H67.536V12.5005H70.0985C71.0555 12.5005 71.7626 12.7111 72.2304 13.1427C72.693 13.5743 72.9269 14.1954 72.9269 14.9639C72.9269 15.7324 72.693 16.3482 72.2198 16.8114C71.7466 17.2694 71.0395 17.501 70.0932 17.501Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3676 12.4983V16.9074H83.4153V18.3263H78.3676V22.8668H84.0118V24.2857H76.5562V11.0794H84.0118V12.4983H78.3676V12.4983Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7811 11.0794V12.4795H91.1147V24.2857H89.3566V12.4795H85.6687V11.0794H94.7758H94.7811Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M107.207 11.0794V24.2857H105.521V18.2958H98.9523V24.2857H97.2664V11.0794H98.9523V16.8799H105.521V11.0794H107.207Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M112.178 11.0794V24.2857H110.521V11.0794H112.178Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M126.26 24.2857H124.471L117.281 13.7858V24.2857H115.491V11.0794H117.281L124.471 21.5583V11.0794H126.26V24.2857Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M136.308 24.2857L130.568 18.2589V24.2857H128.746V11.0794H130.568V17.2009L136.33 11.0794H138.631L132.307 17.6904L138.686 24.2857H136.308Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.6779 34.8198C75.0906 33.825 74.2454 33.0565 73.1476 32.5196C72.0499 31.9827 70.7491 31.7143 69.2452 31.7143H64.9585V44.9206H69.2452C70.7491 44.9206 72.0499 44.6627 73.1476 44.1364C74.2509 43.6153 75.0906 42.8521 75.6779 41.8625C76.2652 40.8677 76.5561 39.6992 76.5561 38.3464C76.5561 36.9937 76.2652 35.8199 75.6779 34.8198ZM74.7229 38.3464C74.7229 39.9781 74.2509 41.2467 73.3178 42.1467H73.3233C72.3847 43.0468 71.029 43.4995 69.2507 43.4995H66.7588V33.1144H69.2507C71.018 33.1144 72.3682 33.5776 73.3123 34.4987C74.2509 35.4199 74.7229 36.7147 74.7229 38.3464Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0246 33.1332V37.5423H85.0723V38.9612H80.0246V43.5017H85.6688V44.9206H78.2131V31.7143H85.6688V33.1332H80.0246V33.1332Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M102.237 31.7143V44.9206H100.529V35.0702L96.2185 44.9206H95.0211L90.6897 35.0543V44.9206H88.9822V31.7143H90.8199L95.6198 42.6303L100.42 31.7143H102.237Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.797 41.9671H112.588L113.658 44.9206H115.491L110.702 31.7143H108.699L103.894 44.9206H105.727L106.797 41.9671ZM109.69 33.8527L112.095 40.5591H112.09H107.284L109.69 33.8527Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M127.917 44.9206H126.128L118.937 34.4207V44.9206H117.148V31.7143H118.937L126.128 42.1932V31.7143H127.917V44.9206Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.122 34.8198C140.534 33.825 139.689 33.0565 138.591 32.5196C137.494 31.9827 136.193 31.7143 134.689 31.7143H130.402V44.9206H134.689C136.193 44.9206 137.494 44.6627 138.591 44.1364C139.695 43.6153 140.534 42.8521 141.122 41.8625C141.709 40.8677 142 39.6992 142 38.3464C142 36.9937 141.709 35.8199 141.122 34.8198ZM140.167 38.3464C140.167 39.9781 139.695 41.2467 138.762 42.1467H138.767C137.829 43.0468 136.473 43.4995 134.695 43.4995H132.203V33.1144H134.695C136.462 33.1144 137.812 33.5776 138.756 34.4987C139.695 35.4199 140.167 36.7147 140.167 38.3464Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d3c19eb950d9322b2f94a6d29cf3ca97.svg";
export { ForwardRef as ReactComponent };